/** @format */

import {Period} from 'components/PeriodSelector/model';

import {SensorsStat} from './helpers/getSensorsStat';

export const PERIODS: {
  key: Period;
  name: string;
}[] = [
  {
    key: 'quarter',
    name: '3 месяца',
  },
  {
    key: 'month',
    name: 'Месяц',
  },
  {
    key: 'week',
    name: 'Неделя',
  },
];

export const CAN_SWIPE_LIST: Period[] = ['quarter', 'month', 'week'];

export const DEFAULT_SENSORS_STAT: SensorsStat = {
  sensors: [],
  foundAtPeriodStart: 0,
  foundNew: 0,
  foundFixed: 0,
  leftAtPeriodEnd: 0,
};
